import { render, staticRenderFns } from "./sheet.vue?vue&type=template&id=a60a1b6e&scoped=true&"
import script from "./sheet.vue?vue&type=script&lang=js&"
export * from "./sheet.vue?vue&type=script&lang=js&"
import style0 from "./sheet.vue?vue&type=style&index=0&id=a60a1b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60a1b6e",
  null
  
)

export default component.exports